import dayjs from "dayjs";
import { FileInput, FileType } from "components/FileInput/FileInput";
import { MM_SPACE_YYYY, MMM } from "constants/date";

const FILED_COPY_ACCEPT = {
  "application/pdf": [".pdf"],
  "image/*": [".png", ".jpeg", ".jpg"],
};

const isFile = (file: FileType): file is File => file instanceof File;

export const FilingFiledCopyRow = ({
  stateName,
  periodStartDate,
  periodEndDate,
  file,
  onFileChange,
}: {
  stateName: string;
  periodStartDate: string;
  periodEndDate: string;
  file: File | null;
  onFileChange: (file: File | null) => void;
}) => {
  const handleDrop = (files: FileType[]) => {
    const droppedFile = files[0];
    onFileChange(droppedFile && isFile(droppedFile) ? droppedFile : null);
  };

  const handleDelete = () => {
    onFileChange(null);
  };

  return (
    <div className="t-grid t-grid-cols-2 t-gap-4 t-items-start t-py-3 t-border-0 t-border-b t-border-solid t-border-neutral-0">
      <div className="t-pt-2">
        <p className="t-m-0 t-text-body-sm t-text-text-100">{stateName}</p>
        <p className="t-m-0 t-text-body-sm t-text-text-30">
          {dayjs(periodStartDate).format(MMM)} -{" "}
          {dayjs(periodEndDate).format(MM_SPACE_YYYY)}
        </p>
      </div>
      <FileInput
        block
        multiple={false}
        file={file}
        onDrop={handleDrop}
        onDelete={handleDelete}
        accept={FILED_COPY_ACCEPT}
      />
    </div>
  );
};
